module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"keys":{"api-version":"Versão da API"}},"en-US":{"keys":{"api-version":"API version"}}}')
  delete Component.options._Ctor
}
